/* ============================================================
   artvision® · TEILEN
   Ein Knopf, zwei Wege: wo das Gerät ein eigenes Teilen-Blatt
   mitbringt (Mobil, Safari), öffnet es sich. Sonst klappt ein
   kleines Menü mit den üblichen Kanälen und „Link kopieren" auf.

   Aufruf im Markup:
     <button data-av-share
             data-share-title="…"
             data-share-url="https://…"
             data-share-text="…optional…">Teilen</button>
   ============================================================ */

(function () {
  'use strict';

  var OPEN = null;

  var CHANNELS = [
    {
      key: 'whatsapp',
      label: 'WhatsApp',
      build: function (d) {
        return 'https://wa.me/?text=' + enc(d.title + ' ' + d.url);
      }
    },
    {
      key: 'facebook',
      label: 'Facebook',
      build: function (d) {
        return 'https://www.facebook.com/sharer/sharer.php?u=' + enc(d.url);
      }
    },
    {
      key: 'x',
      label: 'X',
      build: function (d) {
        return 'https://twitter.com/intent/tweet?text=' + enc(d.title) + '&url=' + enc(d.url);
      }
    },
    {
      key: 'linkedin',
      label: 'LinkedIn',
      build: function (d) {
        return 'https://www.linkedin.com/sharing/share-offsite/?url=' + enc(d.url);
      }
    },
    {
      key: 'pinterest',
      label: 'Pinterest',
      build: function (d) {
        var u = 'https://www.pinterest.com/pin/create/button/?url=' + enc(d.url) +
          '&description=' + enc(d.title);
        if (d.image) u += '&media=' + enc(d.image);
        return u;
      }
    },
    {
      key: 'mail',
      label: 'E-Mail',
      build: function (d) {
        return 'mailto:?subject=' + enc(d.title) + '&body=' + enc(d.text ? d.text + '\n\n' + d.url : d.url);
      }
    }
  ];

  /* Symbole liegen als <template id="av-share-icons"> in der Seite —
     so kann die Redaktion später die offiziellen Markenzeichen
     einsetzen, ohne dass hier etwas geändert werden muss. */
  function iconFor(key) {
    var tpl = document.getElementById('av-share-icons');
    if (!tpl) return null;
    var found = tpl.content.querySelector('[data-ch="' + key + '"]');
    return found ? found.firstElementChild && found.firstElementChild.cloneNode(true) : null;
  }

  function row(key, label) {
    var icon = iconFor(key);
    var frag = document.createDocumentFragment();
    if (icon) {
      icon.classList.add('av-share-menu__icon');
      icon.setAttribute('aria-hidden', 'true');
      frag.appendChild(icon);
    }
    var text = document.createElement('span');
    text.className = 'av-share-menu__label';
    text.textContent = label;
    frag.appendChild(text);
    return frag;
  }

  function enc(v) {
    return encodeURIComponent(v || '');
  }

  function dataFrom(btn) {
    return {
      title: btn.dataset.shareTitle || document.title,
      url: btn.dataset.shareUrl || window.location.href,
      text: btn.dataset.shareText || '',
      image: btn.dataset.shareImage || ''
    };
  }

  function close() {
    if (!OPEN) return;
    OPEN.menu.remove();
    OPEN.btn.setAttribute('aria-expanded', 'false');
    OPEN = null;
    document.removeEventListener('click', onDocClick, true);
    document.removeEventListener('keydown', onKey, true);
  }

  function onDocClick(e) {
    if (!OPEN) return;
    if (OPEN.menu.contains(e.target) || OPEN.btn.contains(e.target)) return;
    close();
  }

  function onKey(e) {
    if (e.key === 'Escape') {
      var btn = OPEN && OPEN.btn;
      close();
      if (btn) btn.focus();
    }
  }

  function copy(url, item) {
    var done = function () {
      var label = item.querySelector('.av-share-menu__label') || item;
      var before = label.textContent;
      label.textContent = 'Link kopiert';
      item.classList.add('is-done');
      setTimeout(function () {
        label.textContent = before;
        item.classList.remove('is-done');
        close();
      }, 1200);
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(done, function () {
        fallbackCopy(url, done);
      });
    } else {
      fallbackCopy(url, done);
    }
  }

  /* Ohne Clipboard-API (ältere Browser, unsichere Verbindung):
     unsichtbares Feld, markieren, kopieren. */
  function fallbackCopy(url, done) {
    var field = document.createElement('textarea');
    field.value = url;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    try {
      document.execCommand('copy');
      done();
    } catch (e) {
      /* Letzter Ausweg: nichts tun, das Menü bleibt offen. */
    }
    field.remove();
  }

  function open(btn) {
    var d = dataFrom(btn);
    var menu = document.createElement('div');
    menu.className = 'av-share-menu';
    menu.setAttribute('role', 'menu');

    var head = document.createElement('p');
    head.className = 'av-share-menu__head';
    head.textContent = btn.dataset.menuLabel || 'Teilen über';
    menu.appendChild(head);

    CHANNELS.forEach(function (channel) {
      var a = document.createElement('a');
      a.className = 'av-share-menu__item';
      a.setAttribute('role', 'menuitem');
      a.href = channel.build(d);
      a.appendChild(row(channel.key, channel.label));
      if (channel.key !== 'mail') {
        a.target = '_blank';
        a.rel = 'noopener';
      }
      a.addEventListener('click', function () {
        setTimeout(close, 0);
      });
      menu.appendChild(a);
    });

    var copyItem = document.createElement('button');
    copyItem.type = 'button';
    copyItem.className = 'av-share-menu__item av-share-menu__item--copy';
    copyItem.setAttribute('role', 'menuitem');
    copyItem.appendChild(row('copy', btn.dataset.copyLabel || 'Link kopieren'));
    copyItem.addEventListener('click', function () {
      copy(d.url, copyItem);
    });
    menu.appendChild(copyItem);

    var wrap = btn.parentNode;
    if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
    wrap.appendChild(menu);

    btn.setAttribute('aria-expanded', 'true');
    OPEN = { btn: btn, menu: menu };

    /* Erst im nächsten Tick lauschen, sonst schließt der Klick,
       der das Menü geöffnet hat, es sofort wieder. */
    setTimeout(function () {
      document.addEventListener('click', onDocClick, true);
      document.addEventListener('keydown', onKey, true);
    }, 0);
  }

  /* Eigener Knopf „Link kopieren" — ohne Menü, direkt in die
     Zwischenablage. Gleiche Mechanik wie im Menü. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-av-copy]');
    if (!btn) return;
    e.preventDefault();

    var url = btn.getAttribute('data-av-copy') || window.location.href;
    var before = btn.textContent;
    var restore = function () {
      btn.textContent = btn.dataset.copiedLabel || 'Link kopiert';
      setTimeout(function () { btn.textContent = before; }, 1600);
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(restore, function () {
        fallbackCopy(url, restore);
      });
    } else {
      fallbackCopy(url, restore);
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-av-share]');
    if (!btn) return;
    e.preventDefault();

    if (OPEN && OPEN.btn === btn) {
      close();
      return;
    }
    close();

    var d = dataFrom(btn);

    /* Das Teilen-Blatt des Geräts ist immer die bessere Wahl —
       dort stehen die Apps, die der Nutzer wirklich benutzt. */
    if (navigator.share) {
      navigator.share({ title: d.title, text: d.text, url: d.url }).catch(function (err) {
        /* Abbruch durch den Nutzer ist kein Fehler — dann bleibt es dabei. */
        if (err && err.name === 'AbortError') return;
        open(btn);
      });
      return;
    }

    open(btn);
  });
})();
